import Molde from "./MoldeTourTradicional";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import React from 'react';


export default function ValleSagrado() {
  return (
    <>
      <Molde
        image={"/images/valle-sagrado-portada.jpg"}
        title={"VALLE SAGRADO"}
        subtitle={"(FULL DAY)"}
        description={
          "El tour del Valle Sagrado es uno de los tours más populares de la región. El Valle Sagrado de los Incas fue un área crucial para el imperio Inca y funcionó como un centro agrícola, espiritual y político para ellos. A lo largo de su recorrido, se pueden encontrar muchos sitios incas y preincas y el recorrido del Valle Sagrado visita los 2 sitios principales, Pisac y Ollantaytambo. Con una duración de un día completo, podrá apreciar los finos trabajos de artesanía que produjeron los incas y ver el hermoso paisaje del Valle Sagrado. Muchos turistas optan por hacer este recorrido justo antes de su visita a Machu Picchu, ya que puede optar por terminar en Ollantaytambo desde donde toma el tren a Aguas Calientes (el pueblo en la base de Machu Picchu)."
        }
        linkForm={"/reservar/citytour-dia"}
        tipoprecio={"Precio por persona"}
        monto={"US$ 30.00"}
        moneda={"DOLARES"}
        picture1={            
          <>
          <div>
            <CardItinerario
              num="01"
              title="INICIO"
              lugar="MIRADOR DE TARAY"
              ></CardItinerario>

              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/taray_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/taray_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/taray_3.png`} alt="" />
              </div>
          </div>
          </>
        }

        picture2={            
          <>
          <div>
            <CardItinerario
              num="02"
              title="PARADA"
              lugar="PISAC"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/pisac_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/pisac_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/pisac_3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture3={            
          <>
          <div>
            <CardItinerario
              num="03"
              title="PARADA"
              lugar="OLLANTAYTAMBO"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ollanta_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ollanta_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ollanta_3.png`} alt="" />
              </div>
            </div>
          </>
        }
        picture4={            
          <>
          <div>
            <CardItinerario
              num="04"
              title="PARADA"
              lugar="CHINCHEROS"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/chinchero_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/chinchero_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/chinchero_3.png`} alt="" />
              </div>
            </div>
          </>
        }

        incluye={
          <>
            <p className="text-primary-800 font-light">Transporte turistico</p>
            <p className="text-primary-800 font-light">Guia profesional</p>
            <p className="text-primary-800 font-light">Asistencia permanente</p>
            <p className="text-primary-800 font-light">Almuerzo</p>
          </>
        }
        noIncluye={
          <>
            <p className="text-primary-800 font-light">Boleto turistico </p>
            <p className="text-primary-800 font-light">Gastos extra</p>
            <p className="text-primary-800 font-light">Desayuno</p>
            <p className="text-primary-800 font-light">Cena</p>
          </>
        }
        caracteristica={
            <>
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
                title={"Dificultad"}
                desc={"Facil"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                title={"Tipo Servicio"}
                desc={"Compartido"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                title={"Duración"}
                desc={"Full day"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                title={"Tipo de Tour"}
                desc={"Cultural - trek"}
              />
            </>
          }

        lugarvisita={
                  <>
                    <CardLugar
                      icon={"01"}
                      title={"Tipon"}
                    />
                    <CardLugar
                      icon={"02"}
                      title={"Pikillaqta "}
                    />
                    <CardLugar
                      icon={"03"}
                      title={"Andahuaylillas "}
                    />
                    
                  </>
                }
                
        TourRecomienda={
          <>
            <CardRecomienda
                          img={"/images/montania_colores.png"}
                          title={"MONTAÑA 7 COLORES"}
                          puntuacion={"4.5"}
                          link={'/tour-tradicional/montania-colores'}
                        />
                        <CardRecomienda
                          img={"/images/valle-vip-5.png"}
                          title={"VALLE VIP"}
                          puntuacion={"5"}
                          link={'/tour-tradicional/valle-vip'}
                        />
                        <CardRecomienda
                          img={"/images/laguna_huamantay.png"}
                          title={"LAGUNA HUAMANTAY"}
                          puntuacion={"5"}
                          link={'/tour-tradicional/laguna-huamantay'}
                        />
                        <CardRecomienda
                          img={"/images/maras-moray-4.png"}
                          title={"MARAS-MORAY"}
                          puntuacion={"4.5"}
                          link={'/tour-tradicional/maras-moray'}
                        />
          </>
        }
      />
    </>
  );
}
